import { Result } from '../types';
import {
  ChatBotReportQuery,
  ChatBotReportResponse,
  LiveChatAssignmentsReportQuery,
  LiveChatAssignmentsReportResponse,
  LiveChatSessionMessagesReportQuery,
  LiveChatSessionMessagesReportResponse,
  LiveChatSessionsResponse,
  LiveChatSessionsWaitingResponse,
  OpenAIProjectNamesResponse,
  OpenAIUsageMonthlyReportQuery,
  OpenAIUsageMonthlyReportResponse,
  OpenAIUsageReconciliationQuery,
  OpenAIUsageReconciliationResponse
} from '../types/report';
import { ApiClient } from './apiClient';

export type ReportsRequestOptions = {
  skipErrorNotification?: boolean;
};

export class ReportsService {
  constructor(private apiClient: ApiClient) { }

  async getLiveChatSessions(): Promise<Result<LiveChatSessionsResponse>> {
    return this.apiClient.get<LiveChatSessionsResponse>('/api/reports/live-chat-sessions');
  }

  async getLiveChatSessionsWaiting(): Promise<Result<LiveChatSessionsWaitingResponse>> {
    return this.apiClient.get<LiveChatSessionsWaitingResponse>('/api/reports/live-chat-sessions-waiting');
  }

  async getLiveChatAssignmentsReport(
    payload: LiveChatAssignmentsReportQuery
  ): Promise<Result<LiveChatAssignmentsReportResponse>> {
    return this.apiClient.post<LiveChatAssignmentsReportResponse>(
      '/api/reports/live-chat-assignments-report',
      payload
    );
  }

  async getLiveChatSessionMessagesReport(
    payload: LiveChatSessionMessagesReportQuery
  ): Promise<Result<LiveChatSessionMessagesReportResponse>> {
    return this.apiClient.post<LiveChatSessionMessagesReportResponse>(
      '/api/reports/live-chat-session-messages',
      payload
    );
  }

  async getOpenAIUsageMonthlyReport(
    payload: OpenAIUsageMonthlyReportQuery,
    requestOptions?: ReportsRequestOptions
  ): Promise<Result<OpenAIUsageMonthlyReportResponse>> {
    return this.apiClient.post<OpenAIUsageMonthlyReportResponse>(
      '/api/reports/openai-usage-monthly',
      payload,
      requestOptions?.skipErrorNotification
        ? { skipErrorNotification: true }
        : undefined
    );
  }

  async getOpenAIUsageReconciliation(
    payload: OpenAIUsageReconciliationQuery,
    requestOptions?: ReportsRequestOptions
  ): Promise<Result<OpenAIUsageReconciliationResponse>> {
    return this.apiClient.post<OpenAIUsageReconciliationResponse>(
      '/api/reports/openai-usage-reconciliation',
      payload,
      requestOptions?.skipErrorNotification
        ? { skipErrorNotification: true }
        : undefined
    );
  }

  async getOpenAIProjectNames(
    requestOptions?: ReportsRequestOptions
  ): Promise<Result<OpenAIProjectNamesResponse>> {
    return this.apiClient.get<OpenAIProjectNamesResponse>(
      '/api/reports/openai-project-names',
      undefined,
      requestOptions?.skipErrorNotification ? { skipErrorNotification: true } : undefined
    );
  }

  async getChatBotReport(
    payload: ChatBotReportQuery
  ): Promise<Result<ChatBotReportResponse>> {
    return this.apiClient.post<ChatBotReportResponse>(
      '/api/reports/chat-bot-report',
      payload
    );
  }
}
